import React from 'react';
import { Polygon, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

export interface PentagonMarkerProps {
    key: string;
    color: string;
    position: any;
    radius: number;
    opacity: number;
    fteDVMs: number;
    name: string;
    showTooltip: boolean;
    isAnimated: boolean;
    onClick?: (event: any) => void;
}

export const PentagonMarker = (props: PentagonMarkerProps) => {
    const latFactor = 1 / 110540;
    const lngFactor =
        1 / (111320 * Math.cos((props.position[0] * Math.PI) / 180));
    const sizeLat = props.radius * latFactor;
    const sizeLng = props.radius * lngFactor;

    const points = [];
    for (let i = 0; i < 5; i++) {
        const angle = ((Math.PI * 2) / 5) * i;
        points.push([
            props.position[0] + sizeLat * Math.cos(angle),
            props.position[1] + sizeLng * Math.sin(angle),
        ]);
    }
    const handleClick = (event: any) => {
        if (props.onClick) {
            props.onClick(event);
        }
    };
    return (
        <Polygon
            pane="markerPane"
            eventHandlers={{
                click: handleClick,
            }}
            key={`${props.key}-${props.opacity}`}
            positions={points}
            color="transparent"
            weight={0}
            fillColor={props.color}
            fillOpacity={props.opacity}>
            {!props.isAnimated && props.showTooltip && (
                <Tooltip direction="top">
                    FTE DVMs: {props.fteDVMs} | Type: {props.name}
                </Tooltip>
            )}
        </Polygon>
    );
};
